import { lookupTableReducer, ActionLookupReducer } from 'Modules/core/redux';

import { feedbackActions } from './actions';
import { FeedbackReducer, SetCodeSendTime } from './types';
import { SENDED_CONFIRMATION_TIME } from './constanst';


const initialState: FeedbackReducer = {
    [SENDED_CONFIRMATION_TIME]: {},
    busy: false,
};

const actionLookup: ActionLookupReducer<FeedbackReducer> = {
    [`${feedbackActions.setCodeSendTime}`]: (state, { email, time }: SetCodeSendTime) => ({
        ...state,
        [SENDED_CONFIRMATION_TIME]: {
            ...state[SENDED_CONFIRMATION_TIME],
            [email]: time,
        },
    }),
    [`${feedbackActions.setBusy}`]: (state, busy) => ({
        ...state,
        busy,
    }),
};

export const reducer = lookupTableReducer(initialState, actionLookup);
